import { useMutation, useQueryClient } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { toast } from "sonner";

export const useSortRoomNumbers = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ roomTypeId, roomIds }: { roomTypeId: string; roomIds: string[] }) => {
            const response = await privateApi.post('/v4/room-number/sort', {
                room_type_id: roomTypeId,
                room_ids: roomIds
            });
            return response.data;
        },
        onSuccess: () => {
            // Invalidate the dialog's own room-list query (UpdateRoomNumberDialog.tsx: ['rooms', 'numbers', roomNumberId])
            queryClient.invalidateQueries({
                predicate: (query) => query.queryKey[0] === 'rooms' && query.queryKey[1] === 'numbers'
            });
            // Invalidate useGetAllRoomType.ts's query key (['bookings', 'booking', 'calendar', ...dynamic params])
            // so the calendar / room-number dropdowns refresh once the dialog closes.
            queryClient.invalidateQueries({
                predicate: (query) => query.queryKey[0] === 'bookings' && query.queryKey[1] === 'booking' && query.queryKey[2] === 'calendar'
            });
            // Invalidate useCheckAvi / useCheckAviV4 (queryKey prefix ['booking', 'rooms', 'rates', ...]).
            // Ini sumber data SEMUA dropdown "select room number" (create reservation v4/v5,
            // assign room, move reservation, switch reservation, room maintenance create/update,
            // fix incomplete booking) lewat GET /v4/check-room-rate, yang sekarang diurutkan
            // backend berdasarkan rooms.sort_order. Tanpa invalidasi ini dropdown yang sudah
            // ter-cache tetap memakai urutan lama.
            queryClient.invalidateQueries({
                predicate: (query) =>
                    query.queryKey[0] === 'booking' &&
                    query.queryKey[1] === 'rooms' &&
                    query.queryKey[2] === 'rates'
            });
            toast.success('Room number order updated successfully!');
        },
        onError: (error: any) => {
            console.error("Failed to sort room numbers:", error);
            const errorMessage = error.response?.data?.message || 'Failed to update room number order.';
            toast.error(errorMessage);

            // Heal the UI if the server rejected with a stale/incomplete-list (409) error
            queryClient.invalidateQueries({
                predicate: (query) => query.queryKey[0] === 'rooms' && query.queryKey[1] === 'numbers'
            });
        }
    });
};
